import e from"./VoiceSearch.vue_vue&type=script&lang.js";import{render as r}from"./VoiceSearch.vue_vue&type=template&id=24b0f67a&lang.js";e.render=r,e.__file="src/components/VoiceSearch.vue";export default e;
//# sourceMappingURL=VoiceSearch.vue.js.map
